// extracted by mini-css-extract-plugin
export default {"container":"LanguageSwitcher_container__fxmyX","select":"LanguageSwitcher_select__aup-b","option":"LanguageSwitcher_option__M6Jz7"};